export function timeHorizonToValidityPeriod(item) {
    item.validityPeriod = item.timeHorizon;
    delete item.timeHorizon;

    if (item.validityPeriod) {
        item.validityPeriod = item.validityPeriod.replace("TIME_HORIZON_", "VALIDITY_PERIOD_");
    }

    return item;
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/common/validityPeriodMigration.js
 **/